<template>
  <div class="page-listing_works">
    <div class="c_theme_colorize">
      <nav-bar-artist-gallery-sub v-show="worksTotal>0 || !is_empty_filters"></nav-bar-artist-gallery-sub>

      <div v-show="is_show_collections() && (worksTotal>0 || !is_empty_filters)">
        <artist-collections-sub v-if="to_artist_id>0"/>
        <gallery-collections-sub v-if="to_gallery_id>0"/>
      </div>
    </div>

    <works-sub v-show="worksTotal>0 || !is_empty_filters" :is_mark_work_pro="false"/>

    <div v-show="worksTotal==0 && !worksLoading && is_empty_filters">
      <div class="limiter" style="margin-top: 20px; margin-bottom: 35px">

        <div class="placeholder-box">
          <div class="placeholder-image">
            <img :src="plceholder_src" style="width: 361px"/>
          </div>

          <div class="placeholder-text">
            {{ $t("message.NothingHereYet") }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import NavBarArtistGallerySub from "./NavBarArtistGallerySub";
  import ArtistCollectionsSub from "./ArtistCollectionsSub";
  import WorksSub from "./WorksSub";
  import ArtistWorksMix from '../../../components/ArtistWorksMix';
  import WorksComputedMix from "../../../components/WorksComputedMix";
  import WorksMix from "../../../components/WorksMix";
  import GalleryCollectionsSub from "./GalleryCollectionsSub";

  export default {
    name      : 'artistworkssub',
    props: [
      'filter'
    ],
    components : {
      GalleryCollectionsSub,
      NavBarArtistGallerySub,
      ArtistCollectionsSub,
      WorksSub,
    },
    mixins: [ArtistWorksMix, WorksComputedMix, WorksMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_dark/components/ArtistWorksSub.vue